







































import Vue from 'vue'
import {mapActions, mapMutations, mapState} from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'

export default Vue.extend({
    computed: {
        ...mapState('mapplantsMappa', ['statoRilevamenti']),

        tipoDiIntervento: {
            get(): number {
                return this.$store.state.mapplantsFiltriManutenzione.tipoDiIntervento
            },
            set(value: number) {
                this.SET_TIPO_DI_INTERVENTO(value)
            }
        },
        interventiFitosanitari: {
            get(): any {
                return this.$store.state.mapplantsFiltriCensimento.interventiFitosanitari
            },
            set(value: any) {
                this.setInterventiFitosanitari(value)
                // reset other filters
                this.setPotatura(false)
            }
        },
        potatura: {
            get(): any {
                return this.$store.state.mapplantsFiltriCensimento.potatura
            },
            set(value: boolean) {
                this.setPotatura(value)
                // reset other filters
                this.setInterventiFitosanitari([])
                this.setMonitoraggio(-1)
            }
        },
        filtroUrgenza: {
            get(): any {
                return this.$store.state.mapplantsMappa.filtroUrgenza
            },
            set(value: any) {
                this.SET_FITRO_URGENZA(value)
            }
        },
        monitoraggio: {
            get(): any {
                return this.$store.state.mapplantsFiltriCensimento.monitoraggio
            },
            set(value: any) {
                this.setMonitoraggio(value)
            }
        },
        dataUltimoInterventoEseguitoParsata(): string {
            // leggiamo la data
            moment.locale('it')
            return moment(this.statoRilevamenti.data_ultimo_intervento).format('DD MMMM YYYY')
        }
    },
    methods: {
        ...mapMutations('mapplantsFiltriManutenzione', ['SET_TIPO_DI_INTERVENTO']),
        ...mapActions('mapplantsFiltriCensimento', [
            'setUrgenzaIntervento',
            'setMonitoraggio',
            'setInterventiFitosanitari',
            'setPotatura'
        ]),
        ...mapMutations('mapplantsMappa', ['SET_FITRO_URGENZA']),
        resettaFiltri() {
            this.filtroUrgenza = -1
            this.monitoraggio = -1
            this.interventiFitosanitari = []
            this.potatura = false
        }
    }
})
